AOS.init();

document.addEventListener("DOMContentLoaded", function () {
  // Get all attachment points items
  var attachmentItems = document.querySelectorAll(".attachment-points-item");

  // Attach click event to each attachment points item
  attachmentItems.forEach(function (item) {
    item.addEventListener("click", function () {
      // Remove 'active' class from all items
      attachmentItems.forEach(function (element) {
        element.classList.remove("active");
      });

      // Add 'active' class to the clicked item
      item.classList.add("active");

      // Get the data-anchor attribute value
      var anchor = item.getAttribute("data-anchor");

      // Hide all attachment content
      var attachmentContents = document.querySelectorAll(".attachment_content");
      attachmentContents.forEach(function (content) {
        content.style.display = "none";
      });

      // Show the corresponding attachment content based on data-anchor
      var selectedAttachmentContent = document.querySelector(
        ".attachment_content." + anchor
      );
      if (selectedAttachmentContent) {
        selectedAttachmentContent.style.display = "block";
      }
    });
  });
});

$(window).scroll(function () {
  var newWindowWidth = $(window).width();
  if (newWindowWidth < 481) {
    var scroll = $(window).scrollTop();
    scroll >= 500 && scroll <= 800
      ? ($(".img-block1").addClass("hoverItemcolor"),
        $(".img-block2").removeClass("hoverItemcolor"),
        $(".img-block3").removeClass("hoverItemcolor"),
        $(".img-block4").removeClass("hoverItemcolor"))
      : scroll >= 800 && scroll <= 1100
      ? ($(".img-block1").removeClass("hoverItemcolor"),
        $(".img-block2").addClass("hoverItemcolor"),
        $(".img-block3").removeClass("hoverItemcolor"),
        $(".img-block4").removeClass("hoverItemcolor"))
      : scroll >= 1200 && scroll <= 1500
      ? ($(".img-block1").removeClass("hoverItemcolor"),
        $(".img-block2").removeClass("hoverItemcolor"),
        $(".img-block3").addClass("hoverItemcolor"),
        $(".img-block4").removeClass("hoverItemcolor"))
      : scroll >= 1500 && scroll <= 1800
      ? ($(".img-block1").removeClass("hoverItemcolor"),
        $(".img-block2").removeClass("hoverItemcolor"),
        $(".img-block3").removeClass("hoverItemcolor"),
        $(".img-block4").addClass("hoverItemcolor"))
      : ($(".img-block1").removeClass("hoverItemcolor"),
        $(".img-block2").removeClass("hoverItemcolor"),
        $(".img-block3").removeClass("hoverItemcolor"),
        $(".img-block4").removeClass("hoverItemcolor"));
  } else if (newWindowWidth > 481 && newWindowWidth < 1024) {
    var scroll = $(window).scrollTop();
    scroll >= 400 && scroll <= 800
      ? ($(".img-block1").addClass("hoverItemcolor"),
        $(".img-block2").addClass("hoverItemcolor"),
        $(".img-block3").removeClass("hoverItemcolor"),
        $(".img-block4").removeClass("hoverItemcolor"))
      : scroll >= 800 && scroll <= 1024
      ? ($(".img-block1").removeClass("hoverItemcolor"),
        $(".img-block2").removeClass("hoverItemcolor"),
        $(".img-block3").addClass("hoverItemcolor"),
        $(".img-block4").addClass("hoverItemcolor"))
      : ($(".img-block1").removeClass("hoverItemcolor"),
        $(".img-block2").removeClass("hoverItemcolor"),
        $(".img-block3").removeClass("hoverItemcolor"),
        $(".img-block4").removeClass("hoverItemcolor"));
  } else {
    var scroll = $(window).scrollTop();
    console.log(scroll),
      scroll >= 600 && scroll <= 1e3
        ? ($(".img-block1").addClass("hoverItemcolor"),
          $(".img-block2").addClass("hoverItemcolor"),
          $(".img-block3").removeClass("hoverItemcolor"),
          $(".img-block4").removeClass("hoverItemcolor"))
        : scroll >= 1e3 && scroll <= 1800
        ? ($(".img-block1").removeClass("hoverItemcolor"),
          $(".img-block2").removeClass("hoverItemcolor"),
          $(".img-block3").addClass("hoverItemcolor"),
          $(".img-block4").addClass("hoverItemcolor"))
        : ($(".img-block1").removeClass("hoverItemcolor"),
          $(".img-block2").removeClass("hoverItemcolor"),
          $(".img-block3").removeClass("hoverItemcolor"),
          $(".img-block4").removeClass("hoverItemcolor"));
  }
}),
  jQuery(document).on("ready", function () {
    $(".section--tight").attr("id", "mainprodsection");
  }),
  jQuery(document).on("ready", function () {
    var slider = jQuery(".table-slider-mob");
    slider.slick({
      arrows: !0,
      dots: !1,
      accessibility: !1,
      infinite: !0,
      autoplay: !1,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
  });
//# sourceMappingURL=/cdn/shop/t/8/assets/custom.js.map?v=171813074595496067661701333955
